<template>
  
      <div class="page" :style="{marginTop: calcMargin}">            
         <slot></slot>
      </div>
  
      
  <!-- <Page :top="30"></Page> -->
</template>
<script>
import { defineComponent } from 'vue';
export default defineComponent({
      data() {return {}},
      props:{
        top: {type:Number, default: 30},
      },
      computed:{
            calcMargin(){
                  let p = this.demo.settings.header + this.top 
                  return p + 'px'
            }
      }
});
</script>
<style scoped>
.page{
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
}
</style>